import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import { trackPageView, initAmplitude } from '../utils/amplitude'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.auth)
  const authed = localStorage.getItem('access-token')

  const signInObject = { name: 'login', query: { redirect: to.fullPath } }
  if (requiresAuth && !authed) next(signInObject)

  if (requiresAuth && authed) {
    const [isValidSession] = await Promise.all([
      store.dispatch('validateSession'),
      store.state.authentication && store.state.authentication.role ? () => {} : store.dispatch('profileMe')
    ])
    if (isValidSession) {
      // Se carga una sola vez al entrar (no en cada navegación) para tener los
      // módulos habilitados siempre disponibles en el store — tanto para el
      // bloqueo por URL de abajo como para cualquier otra vista que los use.
      if (!store.state.enabledFinancialModules.loaded) {
        await store.dispatch('getFinancialModules')
      }

      const requiresPermission = to.matched.some(route => route.meta.permission)
      if (requiresPermission) {
        const permissionCode = to.matched.reduce((permission, route) => {
          return route.meta.permission || permission
        }, null)
        const hasPermission = store.state.enabledFinancialModules.modules
          .some(module => module.code === permissionCode)

        if (!hasPermission) {
          return next({ path: '/unauthorized', query: { redirectFrom: to.fullPath } })
        }
      }

      initAmplitude()
      trackPageView({
        routeName: to.name,
        routePath: to.path,
        financial: store.state.authentication.identifier,
        userId: store.state.authentication.userId,
        role: store.state.authentication.role.code
      })
      next()
    } else {
      await store.dispatch('logout')
    }
  } else if (!requiresAuth && authed) {
    next('/')
  }
  trackPageView({
    routeName: to.name,
    routePath: to.path,
    financial: null,
    userId: null,
    role: null
  })
  next()
})

export default router
